export class QueryDBRequest {
    'databaseName';
    'query';
    'lucene';
    'restoreAccountId';
    'destination';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "databaseName",
            "baseName": "databaseName",
            "type": "string",
            "format": ""
        },
        {
            "name": "query",
            "baseName": "query",
            "type": "string",
            "format": ""
        },
        {
            "name": "lucene",
            "baseName": "lucene",
            "type": "LuceneQueryInput",
            "format": ""
        },
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "QueryDBRestoreDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return QueryDBRequest.attributeTypeMap;
    }
    constructor() {
    }
}
